module.exports = __webpack_public_path__ + "static/media/closeDetailed.890fbee3.svg";